import React, { useState } from 'react';
import {
  AutoComplete, Form, FormInstance, Input,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import {
  SubCategory,
  useCategoriesGetAll,
  useSubcategoriesCreate,
  useSubCategoriesGetById,
} from '../../../../../hooks/api/createaccount';

import styles from '../../index.module.scss';

interface StepProps {
  form: FormInstance<any>;
}

export default function ThirdStep({ form }: StepProps): React.ReactElement {
  const [options, setOptions] = useState<
    { value: string; categoryId: string; subCategoryId: string }[]
  >([]);
  const [loading, setLoading] = useState(false);
  const categoriesGetAll = useCategoriesGetAll();
  const subcategoriesCreate = useSubcategoriesCreate();
  const subCategoriesGetById = useSubCategoriesGetById();

  const { data } = categoriesGetAll;

  const fetchOccupations = (query: string) => {
    if (!data?.data) return;

    setLoading(true);

    const filtered = data.data
      .filter((item) => item?.header?.toLowerCase().includes(query.toLowerCase())
        || (Array.isArray(item?.workersKeywords)
          && item.workersKeywords?.some((el) => el?.toLowerCase()?.includes(query?.toLowerCase()))))
      .map((item) => ({
        value: item?.header,
        categoryId: item?.category?.id,
        subCategoryId: item?.id,
        key: item?.id,
        label: (
          <div>
            <div>{item.header}</div>
            {item.workersKeywords ? (
              <div className={styles.keywords}>{item.workersKeywords
                ?.filter((el) => el.toLowerCase().includes(query.toLowerCase())).slice(0, 3)
                .join(', ')}
              </div>
            ) : null}
          </div>
        ),
      }));

    if (query && !filtered.some((item) => item.value === query)) {
      filtered.push({
        key: query,
        value: query,
        categoryId: 'custom',
        subCategoryId: 'custom',
        label: <div>{query}</div>,
      });
    }

    setOptions(filtered);
    setLoading(false);
  };

  return (
    <>
      <h4 className={styles.title}>What is your Occupation?</h4>
      <Form.Item name="subCategoryId" label="" style={{ display: 'none' }} />
      <Form.Item name="categoryId" label="" style={{ display: 'none' }} />
      <Form.Item<SubCategory>
        label=""
        rules={[{ required: true, message: 'Please enter your occupation' }]}
        name="occupation"
      >
        <AutoComplete
          options={options}
          onSearch={fetchOccupations}
          onChange={(value) => {
            if (value === '') {
              form.setFieldValue('categoryId', undefined);
              form.setFieldValue('subCategoryId', undefined);
            }
          }}
          onSelect={(value) => {
            const selectedOption = options.find((opt) => opt.value === value);

            if (selectedOption) {
              form.setFieldValue('categoryId', selectedOption.categoryId);
              form.setFieldValue('subCategoryId', selectedOption.subCategoryId);

              if (selectedOption.categoryId === 'custom') {
                subcategoriesCreate.fetch({ header: value }).then((resp) => {
                  const newCategoryId = resp?.id;

                  subCategoriesGetById.fetch(undefined, newCategoryId);

                  form.setFieldValue('subCategoryId', resp?.id);
                });
              }
            }
          }}
          placeholder="Bartender, Handyman, etc"
          style={{
            width: '100%',
            height: '64px',
            marginTop: '20px',
          }}
        >
          <Input
            size="large"
            suffix={<SearchOutlined />}
            style={{
              height: '64px',
              borderRadius: '13px',
              backgroundColor: '#F4F6FA',
              fontSize: '17px',
            }}
          />
        </AutoComplete>
      </Form.Item>
    </>
  );
}
